


import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Tailoring.css";

const Tailoring = () => {
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [users, setUsers] = useState([]); // Store fetched users
  const [viewdatas,setViewdatas] = useState(null)
  const [view, setView] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    significant: "",
    fatherHusbandName: "",
    address1: "",
    address2: "",
    district: "",
    taluk: "",
    pinCode: "",
    aadharNumber: "",
    courseName: "",
    photo: null,
  });

 

 
  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const userID = localStorage.getItem("UserId"); // Get userID from localStorage
  
      const response = await axios.get("https://ramjitrust.org:4000/tailoring/getUsers");
  
      // Filter users where response.data.userID matches localStorage userID
      const filteredUsers = response.data.filter((user) => user.userID === userID);
  
      setUsers(filteredUsers);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };
  
  



  const [editdata,setEditdata]=useState(null)
   const [edit,setedit]=useState(false) 
   const handleEdit = async (id) => {
    try {
      const getbyid = await axios.get(`https://ramjitrust.org:4000/tailoring/getuser/${id}`);
      setEditdata(getbyid.data);
      setedit(true);
      if (getbyid.data.district) {
        const selectedDistrict = districts.find(d => d.name === getbyid.data.district);
        if (selectedDistrict?.id) {
          fetch(`https://ramjitrust.org:4000/locations/taluks?district_id=${selectedDistrict.id}`)
            .then(res => res.json())
            .then(data => setTaluks(data))
            .catch(err => console.error("Error fetching taluks:", err));
        }
      }
    } catch (err) {
      console.log("Error getting details", err);
    }
  };
  

  const handleEditChange = (e) => {
    const { name, value } = e.target;
  
    setEditdata((prev) => ({
      ...prev,
      [name]: value,
    }));
  
    // If district changes, update Taluk options dynamically
    if (name === "district") {
      const selectedDistrict = districts.find(d => d.name === value);
      if (selectedDistrict?.id) {
        fetch(`https://ramjitrust.org:4000/locations/taluks?district_id=${selectedDistrict.id}`)
          .then(res => res.json())
          .then(data => setTaluks(data))
          .catch(err => console.error("Error fetching taluks:", err));
      } else {
        setTaluks([]);
        setEditdata((prev) => ({ ...prev, taluk: "" })); // Reset taluk field if district changes
      }
    }
  };
  
  
 
  
  // const handleEditChange = (e) => {
  //   const { name, value, files } = e.target;
  
  //   setEditdata((prev) => ({
  //     ...prev,
  //     [name]: files ? files[0] : value, // ✅ Handle file input
  //   }));
  // };
  

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => {
    setShowModal(false);
    setFormData({
      name: "",
      significant: "",
      fatherHusbandName: "",
      address1: "",
      address2: "",
      district: "",
      taluk: "",
      pinCode: "",
      aadharNumber: "",
      courseName: "",
      photo: null,
    });
  };


  const handleupdate = async (e) => {
    e.preventDefault();
  
    const userID = localStorage.getItem("UserId");
    if (!userID) {
      alert("User ID not found! Please log in.");
      return;
    }
  
    const formDataToSend = new FormData();
    Object.entries(editdata).forEach(([key, value]) => {
      formDataToSend.append(key, value);
    });
  
    formDataToSend.append("userID", userID); // Add userID to the form data
  
    try {
      const response = await axios.put(
        `https://ramjitrust.org:4000/tailoring/update/${editdata.id}`,
        formDataToSend,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
  
      alert("User updated successfully!");
      fetchUsers();
      setedit(false);
      setEditdata(null);
    } catch (error) {
      console.error("Error updating user:", error);
      alert("Error updating user.");
    }
  };
  
  
  const handleView = async (id) => {
    try {
      const getvalue = await axios.get(`https://ramjitrust.org:4000/tailoring/getuser/${id}`);
      setViewdatas(getvalue.data);
      setView(true);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  
  
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const userID = localStorage.getItem("UserId");
    const formDataToSend = new FormData();
  
    Object.entries(formData).forEach(([key, value]) => {
      formDataToSend.append(key, value);
    });
  
    formDataToSend.append("userID", userID); // Add userID to the form data
  
    try {
      const response = await axios.post(
        "https://ramjitrust.org:4000/tailoring/addUser",
        formDataToSend,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
  
      alert("User added successfully!");
      setShowModal(false);
            fetchUsers();
    } catch (error) {
      console.error("Error adding user:", error);
      alert("Error adding user.");
    }
  };
  
  
  
  

  
  
  const filteredData = users.filter((user) =>
    user.name.toLowerCase().includes(search.toLowerCase())
  );


  const [districts, setDistricts] = useState([]);
  const [taluks, setTaluks] = useState([]);
   
  useEffect(() => {
    // Fetch Districts from API
    fetch("https://ramjitrust.org:4000/locations/districts")
      .then((res) => res.json())
      .then((data) => setDistricts(data))
      .catch((err) => console.error("Error fetching districts:", err));
  }, []);

  useEffect(() => {
    const selectedDistrict = districts.find(d => d.name === formData.district);
  
    if (selectedDistrict?.id) {
      fetch(`https://ramjitrust.org:4000/locations/taluks?district_id=${selectedDistrict.id}`)
        .then((res) => res.json())
        .then((data) => setTaluks(data))
        .catch((err) => console.error("Error fetching taluks:", err));
    } else {
      setTaluks([]);
    }
  }, [formData.district, districts]); 
  



  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === "file") {
      setFormData((prev) => ({ ...prev, [name]: files[0] })); // Store file properly
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };
  

  return (
    <div className="tailoring-container">
      <h2>Tailoring</h2>

      {/* Search Bar */}
      <div className="search-container">
        <input
          type="text"
          placeholder="Search..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <button className="add-btn" onClick={handleOpenModal}>
          + Add
        </button>
      </div>

      {/* Table */}
      <table>
        <thead>
          <tr>
            <th>S No</th>
            <th>Name</th>
            <th>Course Name</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
  {filteredData
    .sort((a, b) => {
      if (a.status === "Re Submit") return -1; // "Re Submit" at the top
      if (a.status === "Pending" && b.status !== "Re Submit") return -1; // "Pending" below "Re Submit"
      return 1; // Others remain at the bottom
    })
    .map((user, index) => (
      <tr key={user.id}>
        <td>{index + 1}</td>
        <td>{user.name}</td>
        <td>{user.courseName}</td>
        <td className="status" style={{ color: user.status === "Re Submit" ? "red" : "green" }}>
          {user.status || "Pending"}
        </td>
        <td>
          {user.status!=='Approved'&&<button className="resubmit-btn" onClick={() => handleEdit(user.id)}> {user.status === 'Re Submit' ? "Resubmit" : "Edit"}</button>}
          <button  className="view-btn" onClick={() => handleView(user.id)}>View</button>
          
        </td>
      </tr>
    ))}
</tbody>



      </table>

      {/* Add User Modal */}
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            animation: "fadeIn 0.3s ease-in-out",
          }}
        >
          <div
            style={{
              background: "white",
              padding: "20px",
              width: "100%",
              maxWidth: "700px",
              borderRadius: "8px",
              boxShadow: "0 0 15px rgba(0, 0, 0, 0.2)",
              animation: "slideDown 0.3s ease-in-out",
              overflowY: "auto",
              maxHeight: "90vh",
            }}
          >
            <h3>Add Tailoring User</h3>
            <form onSubmit={handleSubmit}>
              {/* First Row: Name, Significant, Father/Husband Name */}
              <div
                style={{ display: "flex", gap: "15px", marginBottom: "15px" }}
              >
                <div style={{ flex: 1 }}>
                  <label style={{ fontWeight: "bold" }}>Name</label>
                  <input
                    type="text"
                    name="name"
                    placeholder="Enter Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                     className="inputStyle"
                  />
                </div>

                <div style={{ flex: 1 }}>
                  <label style={{ fontWeight: "bold" }}>Significant</label>
                  <select
                    name="significant"
                    value={formData.significant}
                    onChange={handleChange}
                    required
                    className="inputStyle"
                  >
                    <option value="">Select</option>
                    <option value="Mr">Mr</option>
                    <option value="Mrs">Mrs</option>
                    <option value="Ms">Ms</option>
                  </select>
                </div>

                <div style={{ flex: 1 }}>
                  <label style={{ fontWeight: "bold" }}>
                    Father or Husband Name
                  </label>
                  <input
                    type="text"
                    name="fatherHusbandName"
                    placeholder="Enter Name"
                    value={formData.fatherHusbandName}
                    onChange={handleChange}
                    required
                     className="inputStyle"
                  />
                </div>
              </div>

              {/* Two-Column Layout for Remaining Fields */}
        <div style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}>
      {[
        { label: "Address 1", name: "address1", required: true },
        { label: "Address 2", name: "address2", required: false },
        { label: "Pin Code", name: "pinCode", required: true },
        { label: "Aadhar Number", name: "aadharNumber", required: true },
      ].map((field, index) => (
        <div key={index} style={{ flex: "1 1 calc(50% - 10px)" }}>
          <label style={{ fontWeight: "bold" }}>{field.label}</label>
          <input
            type="text"
            name={field.name}
            placeholder={`Enter ${field.label}`}
            value={formData[field.name]}
            onChange={handleChange}
            required={field.required}
             className="inputStyle"
          />
        </div>
      ))}

      {/* District Dropdown */}
      <div style={{ flex: "1 1 calc(50% - 10px)" }}>
        <label style={{ fontWeight: "bold" }}>District</label>
        <select
          name="district"
          value={formData.district}
          onChange={handleChange}
          required
           className="inputStyle"
        >
          <option value="">Select District</option>
          {districts.map((district) => (
            <option key={district.id} value={district.name}>
              {district.name}
            </option>
          ))}
        </select>
      </div>

      {/* Taluk Dropdown */}
      <div style={{ flex: "1 1 calc(50% - 10px)" }}>
        <label style={{ fontWeight: "bold" }}>Taluk</label>
        <select
          name="taluk"
          value={formData.taluk}
          onChange={handleChange}
          required
           className="inputStyle"
        >
          <option value="">Select Taluk</option>
          {taluks.map((taluk) => (
            <option key={taluk.id} value={taluk.name}>
              {taluk.name}
            </option>
          ))}
        </select>
      </div>
    </div>

        {/* Course Name (Dropdown) */}
        <div style={{ marginTop: "15px" }}>
          <label style={{ fontWeight: "bold" }}>Course Name</label>
          <select name="courseName" value={formData.courseName} onChange={handleChange} required  className="inputStyle">
  <option value="">Select</option>
  <option value="Tailoring">Tailoring</option>
  <option value="Embroidery">Embroidery</option>
  <option value="Tailoring and Embroidery">Tailoring and Embroidery</option>
  <option value="Aari Works and Designing">Aari Works and Designing</option>
  <option value="Beautician Course">Beautician Course</option>
  <option value="Tally">Tally</option>
  <option value="C++">C++</option>
  <option value="Java">Java</option>
  <option value="PHP">PHP</option>
  <option value="JavaScript">JavaScript</option>
  <option value="Tally ERP 9">Tally ERP 9</option>
  <option value="Desktop Publishing (DTP)">Desktop Publishing (DTP)</option>
</select>

        </div>

              {/* File Upload (Full Width) */}
              <div style={{ marginTop: "15px" }}>
                <label style={{ fontWeight: "bold" }}>Photo</label>
                <input
                  type="file"
                  name="photo"
                  onChange={handleChange}
                  required
                  // style={inputStyle}
                  className="inputStyle"
                />
              </div>

              {/* Form Buttons */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                <button
                  type="button"
                  onClick={handleCloseModal}
                  style={closeBtnStyle}
                  // className='closeBtnStyle'
                >
                  Close
                </button>
                <button type="submit" className="submitBtnStyle">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

     
{view && (
  <div className="overlay">
    <div className="popup">
      <div className="popup-header">
        <h2 style={{ textAlign: "center", fontSize: "24px", fontWeight: "bold" }}>
          View Tailoring User
        </h2>
        <button className="close-btn" onClick={() => setView(false)}>X</button>
      </div>

      <div className="popup-body">
        <div className="view-grid">
          <div className="view-item">
            <strong>Name:</strong> {viewdatas?.name}
          </div>
          <div className="view-item">
            <strong>Significant:</strong> {viewdatas?.significant}
          </div>
          <div className="view-item">
            <strong>Father/Husband Name:</strong> {viewdatas?.fatherHusbandName}
          </div>
          <div className="view-item">
            <strong>Address 1:</strong> {viewdatas?.address1}
          </div>
          <div className="view-item">
            <strong>Address 2:</strong> {viewdatas?.address2}
          </div>
          <div className="view-item">
            <strong>Pin Code:</strong> {viewdatas?.pinCode}
          </div>
          <div className="view-item">
            <strong>Aadhar Number:</strong> {viewdatas?.aadharNumber}
          </div>
          <div className="view-item">
            <strong>District:</strong> {viewdatas?.district}
          </div>
          <div className="view-item">
            <strong>Taluk:</strong> {viewdatas?.taluk}
          </div>
          <div className="view-item">
            <strong>Course Name:</strong> {viewdatas?.courseName}
          </div>
          <div className="view-item">
            <strong>Photo:</strong>
            <br />
            {viewdatas?.photo ? (
              <img 
                src={`https://ramjitrust.org:4000/uploads/Categories/${viewdatas?.photo}`} 
                alt="User" 
                className="user-photo"
              />
            ) : (
              "No Photo Available"
            )}
          </div>
        </div>
      </div>

      <div className="popup-footer">
        <button className="close-btn" onClick={() => setView(false)}>Close</button>
      </div>
    </div>
  </div>
)}






{edit && (
  <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0, 0, 0, 0.5)", display: "flex", justifyContent: "center", alignItems: "center" }}>
    <div style={containerStyle}>
      <h3>Edit Tailoring User</h3>
      {editdata.status === 'Re Submit' && (
        <>
        <div >
          <h5><strong>Changes:</strong> <span style={{color:'red'}}>{editdata.description}</span></h5>
        </div>
       </>
      )}

      <form onSubmit={handleupdate}>
        
        {/* Name, Significant, Father/Husband Name */}
        <div style={{ display: "flex", gap: "15px", marginBottom: "15px" }}>
          <div style={{ flex: 1 }}>
            <label>Name</label>
            <input type="text" name="name" value={editdata.name} onChange={handleEditChange} required className="inputStyle" />
          </div>

          <div style={{ flex: 1 }}>
            <label>Significant</label>
            <select name="significant" value={editdata.significant} onChange={handleEditChange} required className="inputStyle">
              <option value="">Select</option>
              <option value="Mr">Mr</option>
              <option value="Mrs">Mrs</option>
              <option value="Ms">Ms</option>
            </select>
          </div>

          <div style={{ flex: 1 }}>
            <label>Father/Husband Name</label>
            <input type="text" name="fatherHusbandName" value={editdata.fatherHusbandName} onChange={handleEditChange} required className="inputStyle" />
          </div>
        </div>

        {/* Address, Pin Code, Aadhar Number */}
        <div style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}>
          {[
            { label: "Address 1", name: "address1", required: true },
            { label: "Address 2", name: "address2", required: false },
            { label: "Pin Code", name: "pinCode", required: true },
            { label: "Aadhar Number", name: "aadharNumber", required: true },
          ].map((field, index) => (
            <div key={index} style={{ flex: "1 1 calc(50% - 10px)" }}>
              <label>{field.label}</label>
              <input type="text" name={field.name} value={editdata[field.name]} onChange={handleEditChange} required={field.required} className="inputStyle" />
            </div>
          ))}

          {/* District Dropdown */}
          <div style={{ flex: "1 1 calc(50% - 10px)" }}>
            <label>District</label>
            <select name="district" value={editdata.district} onChange={handleEditChange} required className="inputStyle">
              <option value="">Select District</option>
              {districts.map((district) => (
                <option key={district.id} value={district.name}>
                  {district.name}
                </option>
              ))}
            </select>
          </div>

          {/* Taluk Dropdown */}
          <div style={{ flex: "1 1 calc(50% - 10px)" }}>
            <label>Taluk</label>
            <select name="taluk" value={editdata.taluk} onChange={handleEditChange} required className="inputStyle">
              <option value="">Select Taluk</option>
              {taluks.map((taluk) => (
                <option key={taluk.id} value={taluk.name}>
                  {taluk.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Course Name Dropdown */}
        <div style={{ marginTop: "15px" }}>
          <label>Course Name</label>
          <select name="courseName" value={editdata.courseName} onChange={handleEditChange} required className="inputStyle">
            <option value="">Select</option>
            <option value="Tailoring">Tailoring</option>
            <option value="Embroidery">Embroidery</option>
            <option value="Tailoring and Embroidery">Tailoring and Embroidery</option>
            <option value="Aari Works and Designing">Aari Works and Designing</option>
            <option value="Beautician Course">Beautician Course</option>
            <option value="Tally">Tally</option>
            <option value="C++">C++</option>
            <option value="Java">Java</option>
            <option value="PHP">PHP</option>
            <option value="JavaScript">JavaScript</option>
            <option value="Tally ERP 9">Tally ERP 9</option>
            <option value="Desktop Publishing (DTP)">Desktop Publishing (DTP)</option>
          </select>
        </div>

        {/* File Upload */}
        <div style={{ marginTop: "15px" }}>
          <label>Photo</label>
          <input type="file" name="photo" onChange={handleEditChange} className="inputStyle" />
        </div>

        {/* Buttons */}
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
          <button type="button" onClick={()=>setedit(!edit)} className="closeBtnStyle">Close</button>
          <button type="submit" className="submitBtnStyle">Submit</button>
        </div>
      </form>
    </div>
  </div>
)}










    </div>
  );
};
const closeBtnStyle = {
  backgroundColor: "#f44336",
  color: "white",
  border: "none",
  padding: "10px 15px",
  cursor: "pointer",
  borderRadius: "5px",
  fontSize: "16px",
};

const containerStyle = {
  background: "white",
  padding: "20px",
  width: "100%",
  maxWidth: "700px",
  maxHeight: "650px", // Set max height
  borderRadius: "8px",
  boxShadow: "0 0 15px rgba(0, 0, 0, 0.2)",
  overflowY: "auto", // Enable vertical scrolling if content exceeds height
};


export default Tailoring;


